<template>
  <nav class="bg-white mx-4 lg:mx-8 xl:mx-12">
    <div
      class="relative z-10 container mx-auto flex justify-between items-center mt-2 mb-4"
    >
      <button
        @click="navToHome"
        type="button"
        class="text-[#061B44] text-lg font-semibol flex flex-row space-x-1 items-center"
      >
        <img src="../../assets/images/Icon.png" class="h-7 md:h-10" />
        <div class="flex flex-col items-start">
          <p class="text-[#4867C8] font-extrabold text-sm md:text-xl">Subtitles.tech</p>
          <p class="text-[#4867C8] font-medium text-xs md:text-sm">
            {{ $t("subtitling-and-translating") }}
          </p>
          <!-- <img src="../../assets/images/logo.png" class="h-10"/> -->
        </div>
      </button>
      <div
        :class="{
          'space-x-reverse space-x-1': locale === 'ar',
          'space-x-1': locale !== 'ar',
        }"
        class="hidden lg:flex"
      >
        <router-link
          to="/youtube-transcription"
          :class="{'underline' : router.currentRoute.value.name === 'Youtube'}"Add commentMore actions
          class="text-[#061B44] hover:underline decoration-2 underline-offset-4 text-[17px] xl:text-lg font-semibold px-3"
        >
          {{ $t("Youtube") }}
        </router-link>
        <router-link
          to="/video-transcription"
          :class="{'underline' : router.currentRoute.value.name === 'VideoEditor'}"Add commentMore actions
          class="text-[#061B44] hover:underline decoration-2 underline-offset-4 text-[17px] xl:text-lg font-semibold px-3"
        >
          <p>{{ $t("Video") }}</p></router-link
        >
        <router-link
          to="/audio-transcription"
          :class="{'underline' : router.currentRoute.value.name === 'AudioTranscriptor'}"Add commentMore actions
          class="text-[#061B44] hover:underline decoration-2 underline-offset-4 text-[17px] xl:text-lg font-semibold px-3"
        >
          <p>{{ $t("audio-transcript") }}</p></router-link
        >
        <router-link
          to="/pricing"
          :class="{'underline' : router.currentRoute.value.name === 'Pricing'}"Add commentMore actions
          class="text-[#061B44] hover:underline decoration-2 underline-offset-4 text-[17px] xl:text-lg font-semibold px-3"
        >
          <p>{{ $t("pricing") }}</p></router-link
        >
        <router-link
          to="/industries"
          :class="{'underline' : router.currentRoute.value.name === 'Industries'}"
          class="text-[#061B44] hover:underline decoration-2 underline-offset-4 text-[17px] xl:text-lg font-semibold px-3"
        >
          <p>{{ $t('industries') }}</p></router-link
        >
      </div>
      <div class="space-x-4 hidden lg:flex lg:items-center">
        <button
          @click.prevent="toggleLocalMenu"
          class="flex flex-row space-x-2 justify-center items-center pr-3"
        >
          <img
            :src="`https://hatscripts.github.io/circle-flags/flags/${currentFlag}.svg`"
            width="18"
          />
          <p
            :class="{ 'pr-2': locale === 'ar' }"
            class="text-slate-800 font-semibold text-base xl:text-lg"
          >
            {{ prefStore.local.toUpperCase() }}
          </p>
        </button>
        <!-- locale list desktop -->
        <div
          v-if="activitesStore.localDropDown"
          :class="{
            'left-24 flex flex-col items-end': locale === 'ar',
            'right-36': locale !== 'ar',
          }"
          class="z-1 absolute top-14 -mt-2 overflow-auto rounded-lg shadow-lg w-28 bg-white border py-2"
        >
          <button
            v-for="lang in langsList"
            @click="changeLocal(lang.name.toLowerCase())"
            type="button"
            :class="{
              'flex-row-reverse': locale === 'ar',
              'flex-row': locale !== 'ar',
            }"
            class="flex justify-center items-center space-x-2 px-4 py-2 text-slate-800 font-semibold h-10"
          >
            <img
              :src="`https://hatscripts.github.io/circle-flags/flags/${lang.flag}.svg`"
              width="22"
            />
            <p class="text-lg font-semibold text-slate-900 pb-1">
              {{ lang.name }}
            </p>
          </button>
        </div>
        <div v-if="!authStore.token">
          <router-link
            v-if="router.currentRoute.value.name != 'Signin'"
            to="/signing"
            class="text-[#4867C8] text-base font-semibol"
            ><button
              class="bg-[#4867C8] hover:bg-[#20326A] text-white font-semibold px-4 xl:px-12 rounded-lg h-8"
            >
              {{ $t("sign-in") }}
            </button></router-link
          >
          <router-link
            v-else
            to="/signing-up"
            class="text-[#4867C8] text-base font-semibol"
            ><button
              class="bg-[#4867C8] hover:bg-[#20326A] text-white font-semibold px-8 xl:px-12 rounded-lg h-8"
            >
              {{ $t("Sign_up") }}
            </button></router-link
          >
        </div>
        <div v-else class="flex flex-row">
          <button
            @click.prevent="openNotificationTab"
            type="button"
            class="flex relative justify-center items-center select-none text-[#061B44] text-xl font-bold p-2 m-2 rounded-full h-10 w-10"
          >
            <svg
              width="20"
              height="20"
              class="fill-[#061B44]"
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 611.999 611.999"
              xml:space="preserve"
            >
              <g>
                <g>
                  <g>
                    <path
                      d="M570.107,500.254c-65.037-29.371-67.511-155.441-67.559-158.622v-84.578c0-81.402-49.742-151.399-120.427-181.203
				C381.969,34,347.883,0,306.001,0c-41.883,0-75.968,34.002-76.121,75.849c-70.682,29.804-120.425,99.801-120.425,181.203v84.578
				c-0.046,3.181-2.522,129.251-67.561,158.622c-7.409,3.347-11.481,11.412-9.768,19.36c1.711,7.949,8.74,13.626,16.871,13.626
				h164.88c3.38,18.594,12.172,35.892,25.619,49.903c17.86,18.608,41.479,28.856,66.502,28.856
				c25.025,0,48.644-10.248,66.502-28.856c13.449-14.012,22.241-31.311,25.619-49.903h164.88c8.131,0,15.159-5.676,16.872-13.626
				C581.586,511.664,577.516,503.6,570.107,500.254z M484.434,439.859c6.837,20.728,16.518,41.544,30.246,58.866H97.32
				c13.726-17.32,23.407-38.135,30.244-58.866H484.434z M306.001,34.515c18.945,0,34.963,12.73,39.975,30.082
				c-12.912-2.678-26.282-4.09-39.975-4.09s-27.063,1.411-39.975,4.09C271.039,47.246,287.057,34.515,306.001,34.515z
				 M143.97,341.736v-84.685c0-89.343,72.686-162.029,162.031-162.029s162.031,72.686,162.031,162.029v84.826
				c0.023,2.596,0.427,29.879,7.303,63.465H136.663C143.543,371.724,143.949,344.393,143.97,341.736z M306.001,577.485
				c-26.341,0-49.33-18.992-56.709-44.246h113.416C355.329,558.493,332.344,577.485,306.001,577.485z"
                    />
                    <path
                      d="M306.001,119.235c-74.25,0-134.657,60.405-134.657,134.654c0,9.531,7.727,17.258,17.258,17.258
				c9.531,0,17.258-7.727,17.258-17.258c0-55.217,44.923-100.139,100.142-100.139c9.531,0,17.258-7.727,17.258-17.258
				C323.259,126.96,315.532,119.235,306.001,119.235z"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <span
              v-if="unseen != 0"
              class="icon-button__badge absolute top-0 right-0 w-6 h-4 bg-red-500 text-white font-medium text-sm flex items-center justify-center rounded-full"
              >{{ unseen }}</span
            >
          </button>
          <button
            id="dropdown-toggle-btn"
            data-dropdown-toggle="dropdownInformation"
            @click.prevent="toggleDropDownMenu"
            type="button"
            class="flex justify-center items-center select-none text-[#061B44] text-xl font-bold p-2 m-2 rounded-full h-10 w-10"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              class="fill-[#061B44]"
              xmlns="http://www.w3.org/2000/svg"
              fill-rule="evenodd"
              clip-rule="evenodd"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <title>profile [#1335]</title>
                <desc>Created with Sketch.</desc>
                <defs></defs>
                <g
                  id="Page-1"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="Dribbble-Light-Preview"
                    transform="translate(-420.000000, -2159.000000)"
                    fill="#000000"
                  >
                    <g id="icons" transform="translate(56.000000, 160.000000)">
                      <path
                        d="M374,2009 C371.794,2009 370,2007.206 370,2005 C370,2002.794 371.794,2001 374,2001 C376.206,2001 378,2002.794 378,2005 C378,2007.206 376.206,2009 374,2009 M377.758,2009.673 C379.124,2008.574 380,2006.89 380,2005 C380,2001.686 377.314,1999 374,1999 C370.686,1999 368,2001.686 368,2005 C368,2006.89 368.876,2008.574 370.242,2009.673 C366.583,2011.048 364,2014.445 364,2019 L366,2019 C366,2014 369.589,2011 374,2011 C378.411,2011 382,2014 382,2019 L384,2019 C384,2014.445 381.417,2011.048 377.758,2009.673"
                        id="profile-[#1335]"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <div
            :class="{
              hidden: !showNotificationPanel,
            }"
          >
            <Notifications />
          </div>
          <div
            id="dropdownInformation"
            :class="{
              hidden: !activitesStore.settingDropDown,
              block: activitesStore.settingDropDown,
              'right-0': locale !== 'ar',
              'left-0': locale === 'ar',
            }"
            class="z-1 absolute top-14 -mt-2 overflow-auto rounded-lg shadow-lg w-auto bg-white border py-2 min-w-40"
          >
            <button
              @click="navToRoute('settings')"
              type="button"
              class="flex flex-row justify-center items-center space-x-2 px-4 py-2 text-slate-800 font-semibold h-10"
            >
              <i class="pi pi-cog text-lg"></i>

              <p
                :class="{ 'pr-2': locale === 'ar' }"
                class="text-lg font-semibold text-slate-900 pb-1"
              >
                {{ $t("settings") }}
              </p>
            </button>
            <button
              @click="navToRoute('orders')"
              type="button"
              class="flex flex-row justify-center items-center space-x-2 px-4 py-2 text-slate-800 font-semibold h-10"
            >
              <i class="pi pi-shopping-cart text-lg"></i>
              <p
                :class="{ 'pr-2': locale === 'ar' }"
                class="text-lg font-semibold text-slate-900 pb-1"
              >
                {{ $t("orders") }}
              </p>
            </button>
            <button
              @click="navToRoute('support')"
              type="button"
              class="flex flex-row justify-center items-center space-x-2 px-4 py-2 text-slate-800 font-semibold h-10"
            >
              <svg
                width="20"
                viewBox="0 0 26 26"
                class="fill-slate-800"
                xmlns="http://www.w3.org/2000/svg"
                fill-rule="evenodd"
                clip-rule="evenodd"
              >
                <path
                  d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z"
                />
              </svg>
              <p
                :class="{ 'pr-2': locale === 'ar' }"
                class="text-lg font-semibold text-slate-900 pb-1"
              >
                {{ $t("support") }}
              </p>
            </button>

            <button
              @click="logout"
              type="button"
              class="flex flex-row justify-center items-center space-x-2 px-4 py-2 text-slate-800 font-semibold h-10"
            >
              <i class="pi pi-sign-out text-red-500 text-lg"></i>
              <p
                :class="{ 'pr-2': locale === 'ar' }"
                class="text-lg font-semibold text-red-500 pb-1"
              >
                {{ $t("logout") }}
              </p>
            </button>
          </div>
        </div>
      </div>
      <div class="flex flex-row space-x-3 md:space-x-6 lg:hidden">
        <button
          @click.prevent="toggleLocalMenu"
          :class="{ 'px-4': locale === 'ar' }"
        >
            <img
            :src="`https://hatscripts.github.io/circle-flags/flags/${currentFlag}.svg`"
            class="w-[22px] md:w-[30px]"
          />
        </button>
        <div
          v-if="activitesStore.localDropDown"
          :class="{
            'left-8 md:left-10 flex flex-col items-end': locale === 'ar',
            'right-8 md:right-10': locale !== 'ar',
          }"
          class="block z-1 absolute top-14 md:top-24 -mt-4 overflow-auto rounded-lg shadow-lg w-28 bg-white border py-2"
        >
          <button
            v-for="lang in langsList"
            @click="changeLocal(lang.name.toLowerCase())"
            type="button"
            :class="{
              'flex-row-reverse': locale === 'ar',
              'flex-row': locale !== 'ar',
            }"
            class="flex justify-center items-center space-x-2 px-4 py-2 text-slate-800 font-semibold h-10"
          >
            <img
              :src="`https://hatscripts.github.io/circle-flags/flags/${lang.flag}.svg`"
              width="22"
            />
            <p class="text-lg font-semibold text-slate-900 pb-1">
              {{ lang.name }}
            </p>
          </button>
        </div>
        <button
          data-collapse-toggle="navbar-default"
          type="button"
          @click="toggleMenu"
          class="items-center p-2 w-7 h-7 md:w-10 md:h-10 justify-center text-sm text-white rounded-lg lg:hidden bg-[#76A2F8]"
          aria-controls="navbar-default"
          aria-expanded="false"
        >
          <span class="sr-only">{{ $t("open-main-menu") }}</span>
          <svg
            class="w-3 h-3 md:w-5 md:h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
      </div>
      <!-- hamburger menu -->
      <div
        v-if="showMenu"
        class="absolute top-[50px] md:top-[90px] w-full lg:hidden flex flex-col items-center bg-white border shadow-lg rounded-lg h-auto"
      >
        <div
          class="space-y-4 flex flex-col py-10 items-start justify-center w-[80%]"
        >
          <button
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
            @click="navToRoute('youtube-transcription')"
          >
            <i class="pi pi-youtube text-center"></i>
            <p>
              {{ $t("Youtube") }}
            </p>
          </button>
          <button
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
            @click="navToRoute('video-transcription')"
          >
            <i class="pi pi-video text-center"></i>
            <p>
              {{ $t("Video") }}
            </p>
          </button>
          <button
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
            @click="navToRoute('audio-transcription')"
          >
            <i class="pi pi-microphone text-center"></i>
            <p>
              {{ $t("audio-transcript") }}
            </p>
          </button>
          <button
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
            @click="navToRoute('pricing')"
          >
            <i class="pi pi-dollar"></i>
            <p>
              {{ $t("pricing") }}
            </p>
          </button>
          <button
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
            @click="navToRoute('industries')"
          >
            <i class="pi pi-info-circle text-center"></i>
            <p>
              {{ $t("industries") }}
            </p>
          </button>
          <button
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            v-if="authStore.token"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
            @click="navigateToNotification"
            type="button"
          >
            <i class="pi pi-bell text-center"></i>
            <p>{{ $t("notifications") }}</p>
          </button>
          <button
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            v-if="authStore.token"
            @click="navToRoute('support')"
            type="button"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
          >
            <i class="pi pi-user text-center"></i>
            <p>{{ $t("support") }}</p>
          </button>
          <button
            v-if="authStore.token"
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            @click="navToRoute('settings')"
            type="button"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
          >
            <i class="pi pi-cog text-center"></i>
            <p>{{ $t("settings") }}</p>
          </button>
          <button
            v-if="authStore.token"
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            @click="navToRoute('orders')"
            type="button"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
          >
            <i class="pi pi-shopping-cart text-center"></i>
            <p>{{ $t("orders") }}</p>
          </button>
          <button
            v-if="authStore.token"
            :class="{
              'space-x-reverse space-x-1': locale === 'ar',
              'space-x-1': locale !== 'ar',
            }"
            @click="logout"
            type="button"
            class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
          >
            <i class="pi pi-sign-out text-center"></i>
            <p>{{ $t("logout") }}</p>
          </button>
          <div v-if="!authStore.token" class="w-full">
            <button
              :class="{
                'space-x-reverse space-x-1': locale === 'ar',
                'space-x-1': locale !== 'ar',
              }"
              v-if="router.currentRoute.value.name != 'Signin'"
              @click="navToRoute('signing')"
              class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
            >
              <i class="pi pi-sign-in text-center"></i>
              <p>
                {{ $t("sign-in") }}
              </p>
            </button>
            <button
              :class="{
                'space-x-reverse space-x-1': locale === 'ar',
                'space-x-1': locale !== 'ar',
              }"
              v-else
              class="text-slate-900 text-lg md:text-2xl font-semibold border border-slate-900 rounded-md py-1 w-full flex flex-row items-center justify-center"
              @click="navToRoute('signing-up')"
            >
              <i class="pi pi-sign-in text-center"></i>
              <p>
                {{ $t("Sign_up") }}
              </p>
            </button>
          </div>
          <!-- <div v-if="!authStore.token">
            <button @click="navToRoute('signing-up')">
              <p class="text-white text-2xl font-semibold">
                {{ $t("Sign_up") }}
              </p>
            </button>
          </div> -->
        </div>
        <div class="space-x-4 hidden lg:flex">
          <template v-if="!authStore.token">
            <router-link
              to="/signing"
              class="text-[#061B44] text-lg font-semibol"
              ><button
                :class="{
                  'bg-white':
                    router.currentRoute.value.name == 'Signup' ||
                    router.currentRoute.value.name == 'Signin' ||
                    router.currentRoute.value.name == 'Reset',
                  'text-[#4867C8]':
                    router.currentRoute.value.name == 'Signup' ||
                    router.currentRoute.value.name == 'Signin' ||
                    router.currentRoute.value.name == 'Reset',
                  'text-white':
                    router.currentRoute.value.name != 'Signup' &&
                    router.currentRoute.value.name != 'Signin' &&
                    router.currentRoute.value.name != 'Reset',
                }"
                class="bg-[#4867C8] font-semibold py-2 px-12 rounded-full"
              >
                {{ $t("sign-in") }}
              </button></router-link
            >
          </template>
          <template v-else>
            <div class="m-1 bg-stone-300 rounded-lg shadow-sm">
              <p class="font-medium text-violet-950 py-1/2 px-4">
                ${{ userStore.balance }}
              </p>
            </div>
            <button
              class="relative cursor-pointer"
              @click="openNotificationTab"
            >
              <span class="text-black hover:text-blue-300">
                <img
                  src="../../assets/icons/notificationa.svg"
                  alt="Notifications"
                  height="10"
                  width="25"
                />
              </span>
              <span
                class="absolute -top-1 -right-1 bg-red-500 text-white rounded-full px-2 text-xs"
              >
                {{ unseen }}
              </span>
            </button>
            <button
              type="button"
              class="flex justify-center items-center select-none bg-red-500 border-2 text-white text-xl font-bold p-2 m-2 rounded-full shadow h-20 w-20 focus:outline-none focus:shadow-outline"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-x"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </template>
        </div>
      </div>
    </div>
  </nav>
</template>

<style>
html.is-rtl * {
  direction: rtl;
}
</style>

<script setup lang="ts">
import Notifications from "../modules/notifications/notification_component.vue";
import { useAuthStore } from "../../store/auth";
import { useUserPreference } from "../../store/userPreferences";
import { useUserActivities } from "../../store/userActivities";
import { useNotificationStore } from "../../store/notification";
import { useRouter } from "vue-router";
import { API_BASE_URL, LOGOUT } from "../../utils/appConst";
import { computed, ref } from "vue";
import { useUserProfile } from "../../store/userProfile";
import { useI18n } from "vue-i18n";
import { onBeforeMount } from "vue";
import { useAudioStore } from "../../store/audioStore";
import { useVideoStore } from "../../store/videoStore";
import { useYoutubeStore } from "../../store/youtubeStore";
const router = useRouter();
const audioStore = useAudioStore();
const videoStore = useVideoStore();
const youtubeStore = useYoutubeStore();
const authStore = useAuthStore();
const userStore = useUserProfile();
const prefStore = useUserPreference();
const notificationStore = useNotificationStore();
const activitesStore = useUserActivities();
const logoutUrl = `${API_BASE_URL}${LOGOUT}`;
const showMenu = ref(false);
const unseen = computed(() => authStore.unseenCount);
const { locale } = useI18n();
const showNotificationPanel = computed({
  get: () => notificationStore.showNotificationPanel,
  set: (value) => (notificationStore.showNotificationPanel = value),
});

onBeforeMount(() => {
  if (prefStore.local == "ar") {
    document.querySelector("html")?.classList.add("is-rtl");
  } else {
    document.querySelector("html")?.classList.remove("is-rtl");
  }
});

const langsList = [
  { name: "EN", flag: "us" },
  { name: "AR", flag: "sa" },
  { name: "ES", flag: "es" },
  { name: "CH", flag: "hk" },
  { name: "RU", flag: "ru" },
  { name: "FR", flag: "fr" },
  { name: "TR", flag: "tr" },
];

const currentFlag = computed(() => {
  return langsList.find(
    (element) => element.name.toLowerCase() === prefStore.local.toLowerCase()
  )?.flag;
});
const logout = async () => {
  try {
    showMenu.value = false;
    const response = await fetch(logoutUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
    });
    await response.json();

    userStore.subscriptionType = "";
    userStore.subscriptionStartDate = "";
    userStore.subscriptionEndDate = "";
    authStore.unseenCount = 0;
    resetAudioService();
    resetVideoService();
    resetYoutubeService();
    authStore.logout();
    router.push("/");
  } catch (error) {
    console.error("Authentication failed:", error);
  }
};

const resetAudioService = () => {
  audioStore.receivedCaption = false;
  audioStore.processingStarted = false;
  audioStore.notReadyYet = false;
  audioStore.originalText = "";
  audioStore.translatedText = "";
  audioStore.selectedAudio.name = "";
  audioStore.userInputAudioLink = "";
  audioStore.defaultOriginalText = "";
  audioStore.defaultTranslatedText = "";
  audioStore.isFromNotification = false;
  audioStore.isTargetLanguageSelected = false;
};

const resetVideoService = () => {
  videoStore.receivedCaption = false;
  videoStore.processingStarted = false;
  videoStore.originalVideoSubtitle = "";
  videoStore.prebuildVideoSubtitle = "";
  videoStore.translatedVideoSubtitle = "";
  videoStore.originalText = "";
  videoStore.translatedText = "";
  videoStore.selectedVideo.name = "";
  videoStore.userInputVideoLink = "";
  videoStore.isTargetLanguageSelected = false;
  videoStore.isFromNotification = false;
  videoStore.notReadyYet = false;
  videoStore.defaultOriginalVideoSubtitle = "";
  videoStore.defaultTranslatedVideoSubtitle = "";
  videoStore.defaultOriginalText = "";
  videoStore.defaultTranslatedText = "";
};

const resetYoutubeService = () => {
  youtubeStore.hasVideo = false;
  youtubeStore.isLoading = false;
  youtubeStore.isNotValidLink = false;
  youtubeStore.isTargetLanguageSelected = false;
  youtubeStore.captions = [];
  youtubeStore.activeCaptionLang = "";
  youtubeStore.availableCaptions = [];
  youtubeStore.userInput = "";
  youtubeStore.hasCaption = false;
  youtubeStore.originalVideoSubtitle = "";
  youtubeStore.prebuildVideoSubtitle = "";
  youtubeStore.translatedVideoSubtitle = "";
  youtubeStore.originalText = "";
  youtubeStore.translatedText = "";
  youtubeStore.defaultOriginalVideoSubtitle = "";
  youtubeStore.defaultTranslatedVideoSubtitle = "";
  youtubeStore.defaultOriginalText = "";
  youtubeStore.defaultTranslatedText = "";
  try {
    youtubeStore.currentCaptions = [];
    console.log(youtubeStore.intervalId);
    if (youtubeStore.intervalId != null) {
      clearInterval(youtubeStore.intervalId);
      youtubeStore.intervalId = null;
      youtubeStore.player.value.pauseVideo();
    }
    youtubeStore.player.stopVideo();
  } catch (error) {}
  youtubeStore.isFromNotification = false;
};

const navigateToNotification = () => {
  router.push("/notifications");
};

const openNotificationTab = (e: MouseEvent) => {
  e.stopPropagation();
  notificationStore.togglePanelView();
  if (activitesStore.settingDropDown) {
    activitesStore.settingDropDown = false;
  }
  if (activitesStore.localDropDown) {
    activitesStore.localDropDown = false;
  }
};

const navToHome = () => {
  if (router.currentRoute.value.name === "Home") {
    if (activitesStore.freeYoutubeService) {
      activitesStore.setFreeYoutube(false);
    }
  } else {
    if (activitesStore.freeYoutubeService) {
      activitesStore.setFreeYoutube(false);
    }
    router.push("/");
  }
};

const navToRoute = (name: string) => {
  showMenu.value = false;
  activitesStore.settingDropDown = false;
  router.push(`/${name}`);
};

const toggleMenu = () => {
  showMenu.value = !showMenu.value;
};

router.beforeEach(() => {
  showMenu.value = false;
});

const toggleDropDownMenu = (e: MouseEvent) => {
  e.stopPropagation();
  activitesStore.settingDropDown = !activitesStore.settingDropDown;
  if (activitesStore.localDropDown) {
    activitesStore.localDropDown = false;
  }
  if (notificationStore.showNotificationPanel) {
    notificationStore.showNotificationPanel = false;
  }
};

const changeLocal = (localCode: string) => {
  locale.value = localCode;
  prefStore.setLocal(localCode);
  activitesStore.localDropDown = false;
  if (localCode == "ar") {
    document.querySelector("html")?.classList.add("is-rtl");
  } else {
    document.querySelector("html")?.classList.remove("is-rtl");
  }
};

const toggleLocalMenu = (e: MouseEvent) => {
  e.stopPropagation();
  if (activitesStore.settingDropDown) {
    activitesStore.settingDropDown = false;
  }
  if (notificationStore.showNotificationPanel) {
    notificationStore.showNotificationPanel = false;
  }
  if (activitesStore.localDropDown) {
    activitesStore.localDropDown = false;
  } else {
    activitesStore.localDropDown = true;
  }
};
</script>
